import { ART } from "../assets";
import { Reveal } from "./Reveal";

const items = [
  { label: "Sofa", img: ART.objectSofa },
  { label: "Mattress", img: ART.objectMattress },
  { label: "Boxes", img: ART.objectBoxes },
  { label: "Hot tub", img: ART.objectHotTub },
  { label: "Appliances", img: ART.objectAppliance },
  { label: "Office furniture", img: ART.objectOffice },
];

const more = ["Garage", "Storage unit", "Construction debris", "Estate cleanout"];

export default function Services() {
  return (
    <section className="py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-violet/70">What we pick up</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display text-4xl leading-[1.02] tracking-tight text-charcoal sm:text-5xl lg:text-6xl text-balance">
              If it's in your way, it's in ours.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-charcoal/55">
              From a single sofa to an entire estate — one photo is enough to start.
            </p>
          </Reveal>
        </div>

        {/* scattered, no cards — floating illustrations */}
        <div className="mt-16 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3">
          {items.map((it, i) => (
            <Reveal key={it.label} delay={i * 0.06}>
              <figure className={`group ${i % 2 === 1 ? "sm:mt-12" : ""}`}>
                <div className="overflow-hidden rounded-[1.8rem] bg-white/40 transition-all duration-500 group-hover:-translate-y-2">
                  <img src={it.img} alt={it.label} className="w-full" />
                </div>
                <figcaption className="mt-4 text-center font-display text-xl text-charcoal">
                  {it.label}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-20 rounded-[2.2rem] bg-white/55 p-8 sm:p-10">
            <div className="flex flex-col gap-7 lg:flex-row lg:items-center lg:justify-between">
              <div className="max-w-sm">
                <p className="font-display text-2xl text-charcoal sm:text-3xl">
                  Bigger jobs, welcome too.
                </p>
                <p className="mt-2 text-charcoal/55">
                  Whole spaces — not just single items. One photo covers it all.
                </p>
              </div>
              <div className="flex flex-wrap gap-2.5">
                {more.map((m) => (
                  <span
                    key={m}
                    className="inline-flex items-center gap-2.5 rounded-full border border-stone bg-canvas/60 px-5 py-3 text-sm font-medium text-charcoal transition-colors duration-300 hover:border-violet hover:text-violet"
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-violet/50" />
                    {m}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
